import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import { nmsMenus } from "globals/configuration/nms";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  modes: nmsMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  messages: {
    success: "Create successfully",
    error: "Unable to update data",
  },
  settingsMode: false,
};

const operationURLS = {
  list: "monitorService/list",
  update: "monitorService/update",
  create: "monitorService/create",
  delete: "monitorService/delete/",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Service Code",
      accessor: "code",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      noneditable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Service Master",
    },
    {
      Header: "Service Name",
      accessor: "serviceName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Service Master",
    },
    {
      Header: "Frequency",
      accessor: "duration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Service Master",
    },
    {
      Header: "Port Number",
      accessor: "portNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Service Master",
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
